import { AfterViewInit, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


declare function initSummernote(id:any, placeholder:any, afterInit:any, changeCallback:any ):any;
declare function setSummernoteContent(id:any, value:any ):any;

@Component({
    selector: 'app-summernote-editor',
    templateUrl: './summernote-editor.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SummernoteEditorComponent),
            multi: true,
        },
    ],
})
export class SummernoteEditorComponent implements AfterViewInit, ControlValueAccessor{
    
    @Input() id?: any = 'summerNoteEditor';
    @Input() value?: any;
    @Input() placeholder?: any;
    
    @Output() callback = new EventEmitter();
    @Output() valueChange = new EventEmitter();

    ngAfterViewInit(){

        initSummernote(this.id, this.placeholder, this.afterEditorInit.bind(this), this.changeCallback.bind(this));
    }

    afterEditorInit(){
        this.writeValue(this.value);
    }

    changeCallback(value:any){

       this.update(value);
    }

    update(value:any){
        this.valueChange.emit(value);
        this.callback.emit(value);

        this.onChange(value);
        this.onTouch(value);
    }

    //control value accessor
    onChange: any = () => { };
    onTouch: any = () => { };

    // upon UI element value changes, this method gets triggered
    registerOnChange(fn: any) {
    this.onChange = fn;
    }
    // upon touching the element, this method gets triggered
    registerOnTouched(fn: any) {
    this.onTouch = fn;
    }

    // this method sets the value programmatically
    writeValue(value: any) {
        this.value = value;

        setSummernoteContent(this.id, value);
    }
}
